var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.intervention.types),function(obj,index){return _c('div',{key:index},[_c('b',[_vm._v(_vm._s(obj.type.name))]),_vm._v(": "+_vm._s(obj.count)),_c('br')])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }